<template>
  <div>
    <section id="filters">
      <vs-divider position="left">Where</vs-divider>
      <spatial-filter @onFilterChange="onSpatialFilterChange" />
      <vs-divider position="left">What</vs-divider>
      <app-radio-list :items="variableTypes" @change="updateActiveType" />
      <div class="button">
        <vs-button
          type="filled"
          size="small"
          icon="search"
          color="#19535F"
          @click="
            spatialFilter ? searchProductsInPoint(marker) : searchProducts()
          "
          >Search Data</vs-button
        >
      </div>
    </section>
    <!-- <vs-divider position="left">Results</vs-divider> -->
    <section id="results" class="datatable">
      <products-table
        :products="products"
        @onViewData="onViewData"
      ></products-table>
    </section>
  </div>
</template>
<script>
import SpatialFilterControl from "@/components/ui/SpatialFilterControl";
import AppRadioButtonList from "@/components/ui/AppRadioButtonList";
import TableProducts from "@/components/TableProducts";
import { BTM_PANELS } from "@/constants.js";
import {
  getProducts,
  getProductsInPoint,
  getVariableTypes
} from "@/api/mercurio";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "spatial-filter": SpatialFilterControl,
    "app-radio-list": AppRadioButtonList,
    "products-table": TableProducts
  },
  props: {
    momentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      activeType: {},
      products: [],
      variableTypes: [],
      spatialFilter: false
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker
    }),
    ...mapState({
      activeProduct: state => state.activeProduct
    })
  },
  watch: {
    momentId: function(id) {
      this.init(id);
    }
  },
  mounted() {
    this.init(this.momentId);
  },
  methods: {
    ...mapActions({
      setActiveProduct: "setActiveProduct",
      setBTMDataHubActivePanel: "setBTMDataHubActivePanel",
      toggleLoading: "toggleLoading"
    }),
    init(momentId) {
      this.products = [];
      this.setVariableTypesInMoment(momentId);
    },
    setVariableTypesInMoment(momentId) {
      const params = { momentId: momentId, isRawData: true };
      getVariableTypes(params).then(varTypes => {
        this.variableTypes = varTypes;
      });
    },
    searchProducts() {
      this.toggleLoading(true);

      getProducts(this.momentId, this.activeType.id, true)
        .then(products => {
          this.products = products;
        })
        .catch(error => {
          this.$_utilsMixin_notify("Error", error, 2);
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    searchProductsInPoint(marker) {
      this.toggleLoading(true);

      getProductsInPoint(this.momentId, this.activeType.id, true, marker)
        .then(products => {
          this.products = products;
        })
        .catch(error => {
          this.$_utilsMixin_notify("Error", error, 2);
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    onViewData(item) {
      if (this.spatialFilter) {
        this.setActiveProduct(item);
        this.setBTMDataHubActivePanel(BTM_PANELS.DATAHUB.VIEWER);
      } else {
        this.$_utilsMixin_showWarning(
          "In order to visualize a temporal serie, activate the spatial filter to provide a location"
        );
      }
    },
    onSpatialFilterChange(isActive) {
      if (isActive) {
        this.searchProductsInPoint(this.marker);
      } else {
        this.searchProducts();
      }
      this.spatialFilter = isActive;
    },
    updateActiveType(variableType) {
      this.activeType = variableType;
    }
  }
};
</script>
<style scoped>
.button {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  margin-right: 1rem;
}
.datatable {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
